// Styled components for the payment waiting modal
import styled, {keyframes} from "styled-components";
import {Checkbox, Col, DatePicker, Form, Input, Row, Select, Spin, Typography} from "antd";
import React from "react";
import {FormInstance} from "antd/es/form";
import {InvitationDTO,TransactionRecordDTO} from "@/shared/api/model";
const {Option} = Select;


export interface ConfirmDetailsStepProps {
    form: FormInstance;
}

const {Title, Text} = Typography;

export const pulse = keyframes`
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
`;

export const AnimatedContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
`;

export const PulsingCircle = styled.div`
    background: rgba(24, 144, 255, 0.7);
    border-radius: 50%;
    height: 100px;
    width: 100px;
    animation: ${pulse} 2s infinite;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledSpin = styled(Spin)`
    .ant-spin-dot-item {
        background-color: #ffffff;
    }
`;

export const MessageContainer = styled.div`
    margin-top: 20px;
    text-align: center;
`;



export const CompleteRegistrationStep: React.FC<{
    registrationData: Partial<InvitationDTO>,
    transactionRecord: TransactionRecordDTO | null
}> = ({
          registrationData,
          transactionRecord,
      }) => (
    <div>
        <Title level={4}>Registration Summary</Title>
        <Text>Please review your registration details:</Text>
        <ul>
            <li><Text strong>Phone Number:</Text> {registrationData.phoneNumber}</li>
            <li><Text strong>Name:</Text> {registrationData.name}</li>
            <li><Text strong>Email:</Text> {registrationData.email}</li>
            <li><Text strong>Gender:</Text> {registrationData.gender === 'M' ? 'Male' : 'Female'}</li>
            <li><Text strong>Date of Birth:</Text> {registrationData.dateOfBirth}</li>
            <li><Text strong>Payment Reference:</Text> {transactionRecord?.id}</li>
            <li><Text strong>Transaction Status:</Text> {transactionRecord?.trxStatus}</li>
            <li><Text strong>Initial Deposit:</Text> {transactionRecord?.amount}</li>
        </ul>
    </div>
);


export const VerifyInvitationStep: React.FC = () => (
    <>
        <Form.Item
            name="phoneNumber"
            label="Phone Number"
            rules={[
                {required: true, message: 'Please enter your phone number'},
                {
                    pattern: new RegExp(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/),
                    message: 'Please enter a valid phone number'
                }
            ]}
        >
            <Input size="large" autoComplete="off" placeholder="Enter your phone number"/>
        </Form.Item>

        <Form.Item name="invitationCode" label="Invitation Code"
                   rules={[{required: true, message: 'Please enter the invitation code'}]}>
            <Input size="large" type="password" placeholder="Enter the invitation code(From your Email)"/>
        </Form.Item>
    </>
);
export const AcceptTermsStep: React.FC = () => (
    <Form.Item name="termsAccepted" valuePropName="checked"
               rules={[{validator: (_, value) => value ? Promise.resolve() : Promise.reject('You must accept the terms and conditions')}]}>
        <Checkbox>
            I accept the <a href="/terms-and-conditions" target="_blank">Terms and Conditions</a>
        </Checkbox>
    </Form.Item>
);

export const ConfirmDetailsStep: React.FC<ConfirmDetailsStepProps> = ({form}) => {
    return (
        <>
            <Row gutter={16}>
                <Col xs={24} sm={12}>
                    <Form.Item name="name" label="Full Name"
                               rules={[{required: true, message: 'Please enter your full name'}]}>
                        <Input size="large" autoComplete="off" placeholder="Enter your full name" autoCapitalize="on"/>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item name="email" label="Email"
                               rules={[{type: 'email', message: 'Please enter a valid email'}]}>
                        <Input size="large" autoComplete="off" placeholder="Enter your email address"/>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col xs={24} sm={12}>
                    <Form.Item name="gender" label="Gender"
                               rules={[{required: true, message: 'Please select your gender'}]}>
                        <Select size="large" placeholder="Select your gender">
                            <Option value="M">Male</Option>
                            <Option value="F">Female</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item name="dateOfBirth" label="Date of Birth"
                               rules={[{required: true, message: 'Please select your date of birth'}]}>
                        <DatePicker size="large" style={{width: '100%'}}/>
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};